import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { useAnchor } from "hooks";
import { Features32Content } from "types/graphql/generated";

interface Props {
  content: Features32Content;
}

const Features32: VFC<Props> = withErrorBoundary(({ content: { title, label } }) => {
  useAnchor("features32");

  return (
    <StyledFeatures32 className="features32 Content">
      <div className="Features32__container">
        <Markdown className="Features32__title Font_18_26_600 ">{title}</Markdown>
        <Markdown className="Features32__label Font_18_26_450">{label}</Markdown>
      </div>
    </StyledFeatures32>
  );
}, {});

const StyledFeatures32 = styled.section`
  margin-top: -64px;
  padding-top: 64px;

  .Features32__container {
    display: flex;
    padding: 24px;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.fog["30"]};
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.fog["05"]};
  }

  .Features32__label {
    margin-left: 16px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    .Features32__container {
      flex-direction: column;
    }

    .Features32__label {
      margin-left: 0;
      margin-top: 8px;
    }
  }
`;

gql`
  fragment Features32Content on ComponentFeaturesFeatures32 {
    title
    label
  }
`;

export { Features32 };
export type { Props as Features32Props };
